import { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/auth';

const links = [
  {
    to: '/customers', label: 'Kunden',
    icon: <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />,
  },
  {
    to: '/projects', label: 'Projekte',
    icon: <path d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />,
  },
  {
    to: '/offers', label: 'Angebote',
    icon: <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />,
  },
  {
    to: '/invoices', label: 'Rechnungen',
    icon: <path d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />,
  },
  {
    to: '/time', label: 'Zeiterfassung',
    icon: <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />,
  },
  {
    to: '/schedule', label: 'Plantafel',
    icon: <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />,
  },
  {
    to: '/reports', label: 'Bauberichte',
    icon: <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />,
  },
  {
    to: '/measurements', label: 'Aufmaß',
    icon: <><path d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5" /></>,
  },
  {
    to: '/costs', label: 'Nachkalkulation',
    icon: <path d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />,
  },
  {
    to: '/dunning', label: 'Mahnwesen',
    icon: <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />,
  },
  {
    to: '/articles', label: 'Artikelstamm',
    icon: <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />,
  },
  {
    to: '/delivery-notes', label: 'Lieferscheine',
    icon: <><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /><path d="M9 14l2 2 4-4" /></>,
  },
  {
    to: '/absences', label: 'Abwesenheiten',
    icon: <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2zM12 14l-2 2m0 0l-2-2m2 2V10" />,
  },
  {
    to: '/download', label: 'App-Download',
    icon: <path d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />,
  },
  {
    to: '/ai', label: 'KI-Assistent',
    icon: <><path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" /></>,
  },
  {
    to: '/settings', label: 'Einstellungen',
    icon: <><path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></>,
  },
];

export default function Layout({ children }: { children: React.ReactNode }) {
  const { user, tenant, logout } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [appVersion, setAppVersion] = useState<string>('');

  useEffect(() => {
    fetch('/api/version')
      .then((r) => r.json())
      .then((data) => setAppVersion(data.version))
      .catch(() => {});
  }, []);

  const initials = user?.name
    ?.split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2) || '?';

  return (
    <div className="flex h-screen bg-surface-50">
      {/* ═══ SIDEBAR ═══ */}
      <aside
        className={`${
          collapsed ? 'w-[72px]' : 'w-[260px]'
        } bg-sidebar-bg flex flex-col transition-all duration-300 ease-out relative z-20`}
      >
        {/* Brand + Home */}
        <div className={`h-[68px] flex items-center ${collapsed ? 'justify-center' : 'px-5'} flex-shrink-0`}>
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <button
              onClick={() => navigate('/')}
              className="w-9 h-9 rounded-xl bg-gradient-to-br from-brand-400 to-brand-600 flex items-center justify-center shadow-glow flex-shrink-0 hover:from-brand-300 hover:to-brand-500 transition-all duration-200"
              title="Dashboard"
            >
              <span className="text-white text-sm font-extrabold tracking-tight">S</span>
            </button>
            {!collapsed && (
              <button onClick={() => navigate('/')} className="text-left animate-fade-in min-w-0">
                <span className="text-[17px] font-bold text-white tracking-tight">samoPlan</span>
                <span className="block text-[10px] text-sidebar-text -mt-0.5 font-medium">Handwerksbetrieb</span>
              </button>
            )}
          </div>
          {!collapsed && (
            <button
              onClick={() => navigate('/')}
              className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 flex-shrink-0 ${
                location.pathname === '/'
                  ? 'bg-brand-500/15 text-brand-300'
                  : 'text-sidebar-text hover:bg-white/[0.06] hover:text-slate-200'
              }`}
              title="Dashboard"
            >
              <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
            </button>
          )}
        </div>

        {/* Divider */}
        <div className="mx-4 h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent" />

        {/* Navigation */}
        <nav className={`flex-1 py-4 ${collapsed ? 'px-2' : 'px-3'} space-y-1 overflow-y-auto`}>
          {links.map((l) => {
            const isActive = l.to === '/' ? location.pathname === '/' : location.pathname.startsWith(l.to);
            return (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === '/'}
                className={`relative flex items-center gap-3 ${collapsed ? 'justify-center px-0' : 'px-3'} py-2.5 rounded-xl text-[13px] font-medium transition-all duration-200 group ${
                  isActive
                    ? 'bg-brand-500/15 text-brand-300'
                    : 'text-sidebar-text hover:bg-white/[0.06] hover:text-slate-200'
                }`}
              >
                {/* Active indicator */}
                {isActive && (
                  <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-5 bg-brand-400 rounded-r-full" />
                )}
                <svg className="w-[18px] h-[18px] flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                  {l.icon}
                </svg>
                {!collapsed && <span>{l.label}</span>}
                {/* Tooltip for collapsed */}
                {collapsed && (
                  <div className="absolute left-full ml-3 px-3 py-1.5 bg-slate-800 text-white text-xs font-medium rounded-lg
                    opacity-0 pointer-events-none group-hover:opacity-100 transition-all duration-200
                    whitespace-nowrap z-50 shadow-lg border border-slate-700">
                    {l.label}
                    <div className="absolute right-full top-1/2 -translate-y-1/2 border-[5px] border-transparent border-r-slate-800" />
                  </div>
                )}
              </NavLink>
            );
          })}
        </nav>

        {/* Collapse toggle */}
        <div className={`${collapsed ? 'px-2' : 'px-3'} pb-2`}>
          <button
            onClick={() => setCollapsed(!collapsed)}
            className={`w-full flex items-center ${collapsed ? 'justify-center' : 'px-3'} py-2.5 rounded-xl text-sidebar-text hover:bg-white/[0.06] hover:text-slate-300 transition-all duration-200`}
          >
            <svg
              className={`w-[18px] h-[18px] transition-transform duration-300 ${collapsed ? 'rotate-180' : ''}`}
              fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"
            >
              <path d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
            </svg>
            {!collapsed && <span className="ml-3 text-[13px] font-medium">Einklappen</span>}
          </button>
        </div>

        {/* User section */}
        <div className="border-t border-slate-800 p-3 flex-shrink-0">
          <div className={`flex items-center ${collapsed ? 'justify-center' : 'gap-3'}`}>
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-brand-400 to-purple-500 flex items-center justify-center text-[11px] font-bold text-white flex-shrink-0 ring-2 ring-white/10">
              {initials}
            </div>
            {!collapsed && (
              <div className="min-w-0 flex-1 animate-fade-in">
                <div className="text-[13px] font-semibold text-white truncate">{user?.name}</div>
                <div className="text-[11px] text-sidebar-text truncate">{tenant?.name}</div>
              </div>
            )}
            {!collapsed && (
              <button
                onClick={() => { logout(); navigate('/login'); }}
                className="sp-btn-icon !w-8 !h-8 !text-sidebar-text hover:!bg-white/[0.08] hover:!text-red-400 flex-shrink-0"
                title="Abmelden"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                  <path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </button>
            )}
          </div>
          {appVersion && (
            <div className={`mt-2 text-[10px] text-slate-500 ${collapsed ? 'text-center' : 'px-1'}`}>
              {collapsed ? `v${appVersion}` : `samoPlan v${appVersion}`}
            </div>
          )}
        </div>
      </aside>

      {/* ═══ MAIN CONTENT ═══ */}
      <main className="flex-1 overflow-auto">
        <div className="p-8 max-w-[1360px] mx-auto animate-fade-in" key={location.pathname}>
          {children}
        </div>
      </main>
    </div>
  );
}
